module.exports = function (target, type) {
  return target instanceof type;
};